// @flow
import type {ComponentType, Node} from 'react'
import React, {useCallback, useState} from 'react'
import {type RelayFragmentContainer, graphql, createFragmentContainer} from 'react-relay'

import util from 'utils/MiscUtils'
import DeleteProposalMutation from 'mutations/DeleteProposalMutation'
import type {Proposal} from './types'

type Props = {|
  buttonTag: 'button' | ComponentType<*>,
  label?: string,
  className: ?string,
  onSuccess: () => Promise<void> | void,
  proposal: Proposal,
  toggleDeleted: () => void,
  noDeleteConfig: boolean,
|}

function Delete({buttonTag: Button, className, label, onSuccess, proposal, toggleDeleted, noDeleteConfig}: Props)
  : Node {
  const [disabled, setDisabled] = useState(false)

  const deleteProposal = useCallback(async () => {
    // eslint-disable-next-line no-alert
    if (!window.confirm(I18n.t('proposals.rewrite.delete_confirmation')))
      return

    try {
      toggleDeleted()
      setDisabled(true)
      await DeleteProposalMutation({proposalId: proposal.id}, noDeleteConfig)
    } catch (e) {
      util.warn('There was a problem:', e)
    }

    onSuccess()
  }, [proposal, onSuccess, toggleDeleted, setDisabled, noDeleteConfig])

  return (
    <Button
      className={className}
      disabled={disabled}
      onClick={deleteProposal}
      color="secondary"
      test-id="button"
    >
      {label || I18n.t('react.components.edit_dialog.delete')}
    </Button>
  )
}

Delete.defaultProps = {
  onSuccess: () => {},
  toggleDeleted: () => {},
  className: '',
  noDeleteConfig: false,
}

export default (createFragmentContainer(Delete, {
  proposal: graphql`
    fragment Delete_proposal on Proposal {
      id

      tension {
        id
        isAutogenerated
        databaseId
      }
    }
  `,
}): RelayFragmentContainer<typeof(Delete)>)
